import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { successToast, errorToast } from "../../../components/toastmessage/toastmessage";
import { postBedApiCall } from "./bedService";
import { fetchWardApiCall } from "../ward/watchService";
import { handleValidation } from "./validation";


const useAddBedHook = (initialState) => {
    const navigate = useNavigate();
    const [bedState, setBedState] = useState(initialState);
    const [errors, setError] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBedState((prevFormState) => ({
            ...prevFormState,
            [name]: value,
        }));

    }

    const handleBedSubmit = async (event) => {
        event.preventDefault();
        try {
            let payload = {
                ...bedState,
                createdBy: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.createdBy,
                tenantID: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.tenantID,
                activeStatus: bedState?.activeStatus === "true" ? true : false
            }
            let isValid = await handleValidation(payload);
            if (isValid?.formIsValid) {
                try {
                    await postBedApiCall(payload);
                    successToast("Successfully Inserted");
                    setBedState({initialState})
                } catch (err) {
                    errorToast("Something went wrong")
                }

            } else {
                let inputError = {
                    ...isValid?.errors,
                    formIsValid: isValid?.formIsValid,
                    bedInfoError: isValid?.individualInputErrors
                }
                setError(inputError)
            }
        } catch (e) {
            errorToast("Something went wrong")
        }


    }
    const handleGoBack = () => {
        navigate("/master/bed-list")
    }

    const allowNumbersOnly = (e) => {
        var code = (e.which) ? e.which : e.keyCode;
        if (code > 31 && (code < 48 || code > 57)) {
            e.preventDefault();
        }
    }
    return {
        bedState,
        errors,
        setBedState,
        handleInputChange,
        handleBedSubmit,
        handleGoBack,
        allowNumbersOnly
    }


};


export default useAddBedHook;
